"use client";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { useTheme } from "@emotion/react";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import Image from "next/image";
import ModalComponent from "../Modal";
import ButtonComponent from "../Button";
import { useDispatch, useSelector } from "react-redux";
import { usePathname, useRouter } from "next/navigation";
import { setModalAttributes } from "@/lib/redux/slice/ModalSlice";

const TemporaryServerError = () => {
  const theme = useTheme();
  const router = useRouter();
  const dispatch = useDispatch();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
  const { open, message, type } = useSelector((state) => state?.modal);
  const path = usePathname();
  const handleButtonClick = () => {
    dispatch(setModalAttributes({ open: false, message: "", type: "" }));
    if (path && path !== "/en") {
      router.replace("/");
    }
  };

  return (
    <ModalComponent
      maxWidth={isBelowMd ? "xs" : "md"}
      open={open}
      closeButtonRequired={false}
    >
      <Stack
        sx={{
          backgroundColor: { md: "#F2F7F799" },
          border: { md: "1px solid #F0F0F099", xs: "none" },
          borderRadius: "20px",
        }}
        spacing={3}
        width={"100%"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        pb={{ md: 10, xs: 2 }}
        pt={{ md: 10, xs: 2 }}
      >
        <Image
          src={IMAGES.serviceUnavailable}
          width={isBelowMd ? 200 : 250}
          alt="Service Temporary Unavailable"
        />
        <Stack
          width={{ md: "620px" }}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          spacing={2}
        >
          <Typography
            align="center"
            fontWeight={{ md: 700, xs: 500 }}
            fontSize={{ md: "24px", xs: "16px" }}
            color={WEB_COLORS.darkTeal}
            width={{ md: "553px" }}
          >
            Service Temporarily Unavailable
          </Typography>
          <Typography
            textAlign={"center"}
            fontWeight={400}
            fontSize={{ md: "16px", xs: "14px" }}
            color={WEB_COLORS.textFadeColor}
            mb={2}
          >
            {message}
          </Typography>
        </Stack>
        <Stack width={{ md: "300px", xs: "100%" }} alignItems="center">
          <ButtonComponent onClick={handleButtonClick}>
            Go to homepage
          </ButtonComponent>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default TemporaryServerError;
